import React from 'react'
import ReactDOM from 'react-dom'
import Pages from 'pages'
import reportWebVitals from './reportWebVitals'
import { StyledEngineProvider } from '@material-ui/core/styles'
import './global.scss'

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Pages />
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
